import { DialogActions, SxProps, Theme, styled } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

interface ModalFooterProps {
  sx?: SxProps<Theme>
}

const ModalFooter: FC<PropsWithChildren<ModalFooterProps>> = ({ children, sx }) => (
  <StyledDialogFooter sx={sx}>{children}</StyledDialogFooter>
)

const StyledDialogFooter = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2),
  '& > :not(:first-of-type)': {
    marginLeft: theme.spacing(2),
  },

  '& .save-btn': {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}))

export default ModalFooter
